import React from 'react';
import { CtaButton } from './CtaButton';
export function UrgencySection() {
  return <section className="bg-[#2a1f14] text-white py-20 px-4 border-t border-[#5a4535]" data-id="element-220">
      <div className="max-w-4xl mx-auto text-center" data-id="element-221">
        <div className="bg-[#b5634b]/20 border border-[#b5634b]/50 rounded-lg p-6 mb-16 inline-block" data-id="element-222">
          <p className="font-oswald text-2xl md:text-3xl font-bold text-[#d4956a] uppercase tracking-wide" data-id="element-223">
            ⚠️ Este programa está disponible online por tiempo limitado.
          </p>
          <p className="font-opensans text-xl text-gray-300 mt-2" data-id="element-224">
            Aprovecha el acceso ahora y comienza hoy mismo.
          </p>
        </div>

        <div className="space-y-6 mb-12" data-id="element-225">
          <p className="font-oswald text-3xl md:text-5xl font-bold uppercase text-gray-400" data-id="element-226">
            Tu mente puede ser tu mayor fuente de estrés…
          </p>
          <p className="font-oswald text-4xl md:text-6xl font-bold uppercase text-white drop-shadow-lg" data-id="element-227">
            O tu mayor fuente de claridad.
          </p>
        </div>

        <p className="font-opensans text-2xl md:text-3xl text-[#c9a96e] font-bold mb-12 italic" data-id="element-228">
          La diferencia está en aprender a manejarla.
        </p>

        <div className="pb-10" data-id="element-229">
          <CtaButton text="QUIERO CALMAR MI MENTE AHORA" data-id="element-230" />
        </div>

        <p className="font-opensans text-sm text-gray-500 mt-12" data-id="element-231">
          © {new Date().getFullYear()} Mega Pack Claridad Mental. Todos los
          derechos reservados.
        </p>
      </div>
    </section>;
}